import React, { Fragment } from 'react'
import ScanName from '../components/ScanName'

const BasicInfo = ({ form }) => {
	const { getFieldDecorator } = form
	return (
		<Fragment>
			<ScanName getFieldDecorator={getFieldDecorator} />
		</Fragment>
	)
}

export default BasicInfo
